import React, { CSSProperties, FunctionComponent } from 'react';
import { Input, InputContainer, Label } from './PhoneNumberInput.style';
import SelectInput from './SelectInput';
import ValidationError from './ValidationError';

interface Props {
  label?: string;
  value: string;
  onValueChange: (value: string) => void;
  prefix: string;
  onPrefixChange: (value: string) => void;
  placeholder?: string;
  containerStyle?: CSSProperties;
  testID?: string;
  error?: string | false;
}

const PHONE_PREFIX_OPTIONS = [
  {
    label: '+44',
    value: '+44',
  },
  {
    label: '+353',
    value: '+353',
  },
];

const PhoneNumberInput: FunctionComponent<Props> = (props) => {
  return (
    <div style={props.containerStyle}>
      {props.label && <Label>{props.label}</Label>}

      <InputContainer error={props.error}>
        <SelectInput
          inputStyle={{ boxShadow: 'none', height: 52 }}
          ariaLabel="Phone number prefix"
          id="phoneNumberPrefix"
          options={PHONE_PREFIX_OPTIONS}
          value={props.prefix}
          onChange={props.onPrefixChange}
        />

        <Input
          placeholder={props.placeholder}
          onChange={(e) => props.onValueChange(e.target.value)}
          value={props.value}
          data-testid={props.testID}
        />
      </InputContainer>

      <ValidationError error={props.error} />
    </div>
  );
};

export default PhoneNumberInput;
